import React, { useContext } from "react";
import {
  Container,
  Box,
  IconButton,
  Typography,
  Link,
  Button,
  SvgIcon,
  List,
  ListItem,
  Grid,
} from "@mui/material";

import { LangContext } from "../../LanguageProvider";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: "#000", mt: 1 }}>
      {"Copyright © "}
      <Link color="text.secondary" href="https://rvtk.edu.kz">
        RVTK
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const { translations } = useContext(LangContext);
  return (
    <Container
      sx={{
        backgroundColor: "#f4f4f4",
        paddingY: 6,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        boxShadow: "rgba(0, 0, 0, 0.1)",
        flexWrap: "wrap",
        maxWidth: "none",
        width: "100%",
        height: "auto",
      }}>
      <Grid container spacing={4} sx={{ display: "flex" }}>
        {/* Логотип */}
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <IconButton>
            <img
              src="login.png"
              alt="Logo"
              style={{ width: 100, height: 100 }}
            />
          </IconButton>
          <Copyright />
        </Grid>

        {/* Контактная информация */}
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}>
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: "15px",
                display: "flex",
                justifyContent: "center",
                color: "#000",
              }}>
              {translations["Phone"]}{" "}
            </Typography>
            <Box sx={{ fontSize: "16px" }}>
              <List>
                <ListItem sx={{ fontSize: "20px", color: "#000" }}>
                  8 (7112) 25-50-52
                </ListItem>
                <ListItem sx={{ fontSize: "20px", color: "#000" }}>
                  8 (7112) 51-35-70
                </ListItem>
              </List>
            </Box>
          </Box>
        </Grid>

        {/* Адрес */}
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}>
          <Box sx={{ fontSize: "16px", mb: 2 }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: "15px",
                display: "flex",
                justifyContent: "center",
                color: "#000",
                textAlign: "center",
              }}>
              {translations["adres"]}{" "}
            </Typography>
            <Box
              sx={{
                fontSize: "16px",
                fontWeight: "normal",
                marginTop: "4px",
              }}>
              <Typography
                sx={{
                  fontSize: "15px",
                  color: "#000",
                  textAlign: "center",
                }}>
                Западно-Казахстанcкая область, город Уральск, улица Қайрата
                Жумағалиева, дом 20/1
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Социальные сети и кнопка */}
        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Box
            marginBottom="px"
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: { xs: 1, sm: 4 },
            }}>
            <Link href="https://vk.com/rvtk07" target="_blank" rel="noopener">
              <SvgIcon
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none">
                <path
                  d="M0 23.04C0 12.1788 0 6.74826 3.37413 3.37413C6.74826 0 12.1788 0 23.04 0H24.96C35.8212 0 41.2517 0 44.6259 3.37413C48 6.74826 48 12.1788 48 23.04V24.96C48 35.8212 48 41.2517 44.6259 44.6259C41.2517 48 35.8212 48 24.96 48H23.04C12.1788 48 6.74826 48 3.37413 44.6259C0 41.2517 0 35.8212 0 24.96V23.04Z"
                  fill="#0077FF"
                />
                <path
                  d="M25.54 34.5801C14.6 34.5801 8.3601 27.0801 8.1001 14.6001H13.5801C13.7601 23.7601 17.8 27.6401 21 28.4401V14.6001H26.1602V22.5001C29.3202 22.1601 32.6398 18.5601 33.7598 14.6001H38.9199C38.0599 19.4801 34.4599 23.0801 31.8999 24.5601C34.4599 25.7601 38.5601 28.9001 40.1201 34.5801H34.4399C33.2199 30.7801 30.1802 27.8401 26.1602 27.4401V34.5801H25.54Z"
                  fill="white"
                />
              </SvgIcon>
            </Link>
          </Box>

          <Typography marginTop="20px" sx={{ color: "#000" }}>
            {translations["link"]}
          </Typography>
          <Button
            component="a" // Указываем MUI рендерить эту кнопку как тег <a>
            href="mailto:rvtk@edu.kz" // Используем href, как у обычной ссылки
            sx={{ borderRadius: "80px" }}>
            {translations["write"]}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
